// extracted by mini-css-extract-plugin
module.exports = {"form":"EAFRegister_form__309h2","content":"EAFRegister_content__3VslQ","contentMain":"EAFRegister_contentMain__2Ga7g","select":"EAFRegister_select__cNPPA"};